export default __webpack_public_path__ + "static/media/banner.5340001b.svg";